define('views/modules/setting/business/list/membership-plan-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache',
    // services
    'services/i18n',
    'services/user',
    // views
    'views/parts/form/button',
    // templates
    'text!templates/modules/setting/business/list/membership-plan-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache,
    // services
    i18n,
    User,
    // views
    VButton,
    // templates
    TMembershipPlanListItem
) {

    var VMembershipPlanListItem = Backbone.View.extend({
        template: TMembershipPlanListItem,
        className: "payment-plan-item",

        regions: {
            selectPlan: '.button-select-plan',
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                selectPlan: new VButton({
                    label: i18n.t('payment:upgrade_to_this_plan'),
                    callback: this.onSelectPlanClicked,
                    context: this,
                    icon: false,
                    tcClass: false,
                    class: 'btn-default',
                }),
            };

            this.listenTo(this.model, {
                'remove': this.remove,
            });
        },

        render: function() {
            var view = this.view,
                model = this.model,
                zone = this.zone;

            if (this.options.selectedPlan === model.id) {
                this.el.className += " payment-plan-item-selected";
            }

            var currencyFormatter = new Intl.NumberFormat(User.get('languageCode'), {
                style: 'currency',
                currency: this.options.teamPaymentCurrency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });

            this.$el.empty().append(
                Mustache.render(
                    this.template,
                    Mustache.getContext(
                        {
                            currentPlan: this.options.selectedPlan === model.getName(),
                            name: model.getName(),
                            plan_id: model.id,
                            price: currencyFormatter.format(model.getCurrencies()[this.options.teamPaymentCurrency].price),
                            allowedClient: model.getMaxMembers(),
                            allowedCoach: model.getMaxCoaches()
                        }
                    )
                )
            );

            this.generateZones()
                .assign(view.selectPlan, this.zone.$selectPlan);

            return this;
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onSelectPlanClicked: function() {
            this.model.collection.trigger('payment:select-plan', this.model.getName());
        },
    });

    return VMembershipPlanListItem;

});

